module.exports = __webpack_public_path__ + "media/promo/velle/images/contest-e5bd018bca2f784cec4286e124fa18b0.png";